module.exports = __webpack_public_path__ + "static/media/full_screen.673e2231.svg";